import { UserData } from './types';
import {
  jsonizeIntegratedDrawingData, IntegratedDrawingState,
} from '../reducers/integratedDrawing';
import { PagesState } from '../reducers/pages';
import { PreferenceState } from '../reducers/preference';
import { SpeechState } from '../tts/reducers/speech';
import { ContentStorageState } from '../reducers/contentStorage';
import { MarkerInfo } from '../../../../common/src/ts/types/marker';
import { PictureStorageState, isPictureSavingFinished } from '../drawing/reducers/pictureStorage';
import { BookmarksState } from '../bookmark/reducers/bookmark';
import { DrawingToolState, jsonizeDrawingToolState } from '../drawing/reducers/drawingTool';
import { ViewState } from '../reducers/view';
import { UIState } from '../reducers/ui/ui';

export function downloadBlobAsFile(data: Blob, filename: string): void {
  const link = document.createElement('a');
  if (typeof link.download === 'undefined') {
    // IE does not support 'download' attribute, but has msSaveBlob().
    window.navigator.msSaveBlob(data, filename);
  } else {
    link.href = URL.createObjectURL(data);
    link.download = filename;
    link.dispatchEvent(new MouseEvent('click'));
  }
}

// part of AppStates
interface UserDataSource {
  pages: PagesState;
  preference: PreferenceState;
  drawingTool: DrawingToolState;
  integratedDrawing: IntegratedDrawingState;
  speech: SpeechState;
  contentStorage: ContentStorageState;
  markers: MarkerInfo[];
  bookmarks: BookmarksState;
  view: ViewState;
  ui: UIState;
}

export function createUserData(publicationId: string, states: UserDataSource): UserData {
  return {
    publicationId,

    // This function is called from reducer. Do not set new Date() right now.
    createdAt: null,

    pages: states.pages,
    drawingTool: jsonizeDrawingToolState(states.drawingTool),
    preference: states.preference,
    integratedDrawings: jsonizeIntegratedDrawingData(states.integratedDrawing),
    speech: states.speech,
    contentStorage: states.contentStorage,
    markers: states.markers,
    bookmarks: states.bookmarks,
    popupRects: states.view.popupRects,
    ui: states.ui,
  };
}

export function isReadyToSaveWorkspace(
  savingWorkspace: UserData | null,
  pictureStorage: PictureStorageState<HTMLCanvasElement>,
) {
  if (savingWorkspace === null) {
    // So that !isReadyToSaveWorkspace(prev) && isReadyToSaveWorkspace(current) triggers saving,
    return false;
  }

  return isPictureSavingFinished(pictureStorage);
}

// For browser build.
export function downloadUserData(data: UserData, filename: string): void {
  const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
  downloadBlobAsFile(blob, filename);
}
